<div id="content-wrapper" class="d-flex flex-column">
  <div id="content">
    <app-topbar></app-topbar>
    <div class="container-fluid" id="container-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>